module.exports = __webpack_public_path__ + "static/img/contract1.cc9f1ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contract1.png
// module id = zFi/
// module chunks = 1